import React from 'react';
import { motion } from 'framer-motion';

const ModelPreloader = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 z-10">
      <motion.div
        animate={{
          rotate: 360
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "linear"
        }}
        className="relative w-16 h-16"
      >
        <div className="absolute inset-0 rounded-full border-4 border-gray-200 opacity-25"></div>
        <div className="absolute inset-0 rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
      </motion.div>
      <p className="absolute mt-24 text-white font-medium">Loading 3D Model...</p>
    </div>
  );
};

export default ModelPreloader;